// extracted by mini-css-extract-plugin
module.exports = {"l4pwws6":"l4pwws6"};